export class EditorEvents {
  constructor(instance) {
    this.instance = instance;
    this.editor = instance.getEditor();
    this.spaceMode = false;
    
    this.setupSelectionEvents();
    this.setupDocumentEvents();
    this.setupSpaceEvents();
  }

  setupSelectionEvents() {
    document.addEventListener('mouseup', (event) => {
      if (event.target.closest('.bubble-menu')) return;

      const { from, to } = this.editor.state.selection;
      const text = this.editor.state.doc.textBetween(from, to, ' ');
      
      if (text && text.length >= 5) {
        this.spaceMode = false;
        this.instance.showBubbleMenuIfNeeded('selection');
      } else {
        if (!this.spaceMode) {
          this.instance.hideBubbleMenu();
        }
      }
    });
  }

  setupDocumentEvents() {
    document.addEventListener('mousedown', (event) => {
      if (event.target.closest('.bubble-menu')) return;

      if (this.instance.bubbleMenu && 
          this.instance.bubbleMenu.style.display === 'block') {
        this.instance.hideBubbleMenu();
        this.spaceMode = false;
      }
    });
  }

  setupSpaceEvents() {
    const editorDOM = this.editor.view.dom;
    
    editorDOM.addEventListener('keydown', (event) => {
      if (event.key === ' ') {
        const { $from } = this.editor.state.selection;
        const node = $from.parent;
        
        // Проверяем всю цепочку родителей на наличие списка
        let depth = $from.depth;
        let isInsideList = false;
        
        while (depth > 0) {
          const parent = $from.node(depth);
          if (parent.type.name === 'bulletList' || 
              parent.type.name === 'orderedList' ||
              parent.type.name === 'listItem') {
            isInsideList = true;
            break;
          }
          depth--;
        }

        // Проверяем, что это параграф, он пустой и не внутри списка
        if (node.type.name === 'paragraph' && 
            node.textContent.trim() === '' && 
            !isInsideList) {
          
          event.preventDefault();
          this.spaceMode = !this.spaceMode;
          
          if (this.spaceMode) {
            this.instance.showBubbleMenuIfNeeded('space');
          } else {
            this.instance.hideBubbleMenu();
          }
        } else {
          if (this.spaceMode) {
            this.spaceMode = false;
            this.instance.hideBubbleMenu();
          }
        }
      }
    });
  }

  destroy() {
    document.removeEventListener('mouseup', this.setupSelectionEvents);
    document.removeEventListener('mousedown', this.setupDocumentEvents);
    if (this.editor && this.editor.view && this.editor.view.dom) {
      this.editor.view.dom.removeEventListener('keydown', this.setupSpaceEvents);
    }
  }
}
